import i18n from 'i18next';
import ICU from 'i18next-icu';
import { initReactI18next } from 'react-i18next';
import en from './keys/en.json';
import id from './keys/id-ID.json';
import vi from './keys/vi-VN.json';
import { setCookie } from '../../utils/cookies';

// Showroom links here with ?lang=en|id|vi. Read it here, at boot, because the router redirects
// / to country.features.initialPath on first render and a component effect sees the URL too late.
const params = new URLSearchParams(window.location.search);
const landingLang = { en: 'en', id: 'id-ID', vi: 'vi-VN' }[params.get('lang')];
if (landingLang) {
  setCookie('preferred_language', landingLang, 365);
  // One-time hand-off: drop the param so a reload or bookmark does not re-apply it.
  params.delete('lang');
  const search = params.toString();
  window.history.replaceState(null, '', `${window.location.pathname}${search ? `?${search}` : ''}${window.location.hash}`);
}

i18n
  .use(ICU)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      'id-ID': { translation: id },
      'vi-VN': { translation: vi },
    },
    lng: landingLang || 'en',
    fallbackLng: 'en',
    supportedLngs: ['en', 'id-ID', 'vi-VN'],
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
